import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { EnvelopeIcon, PhoneIcon } from '@motorway/mw-highway-code';

import { formatPhoneNumber } from 'Utilities/helpers';

import { AgentsBox } from 'Storybook/components/local/AgentsBox/AgentsBox';

import LocalTexts from './ContactSalesTeam.json';
import { ContactSalesTeamProps } from './ContactSalesTeam.types';

import styles from './ContactSalesTeam.scss';

const LocalT = new MDText(LocalTexts);

const ContactSalesTeam = ({
  agentsAlign = 'left',
  className,
  detailsClassName,
  email = LocalT.translate('email'),
  infoClassName,
  onCTAClick,
  phoneNumber,
  title = LocalT.translate('title'),
}: ContactSalesTeamProps) => {
  const landline = formatPhoneNumber(phoneNumber);

  let priority;
  if (phoneNumber) {
    priority = formatPhoneNumber(phoneNumber);
  }

  return (
    <div className={cx(styles.component, className)}>
      <div className={cx(styles.agentsBox, styles[agentsAlign])}>
        <AgentsBox />
      </div>
      <div className={cx(styles.info, infoClassName)}>
        <h4 className="mw-title-title6">{title}</h4>
      </div>
      <ul className={cx(styles.contactDetails, detailsClassName)}>
        <li>
          <PhoneIcon />
          <a
            className="mw-link mw-link-black"
            href={`tel:${priority?.number || landline.number}`}
            onClick={onCTAClick}
          >{priority?.pretty || landline.pretty}</a>
        </li>
        <li>
          <EnvelopeIcon />
          <a
            className="mw-link mw-link-black"
            href={`mailto:${email}`}
            onClick={onCTAClick}
          >{email}</a>
        </li>
      </ul>
    </div>
  );
};

export default ContactSalesTeam;
